/**
 * 新用户首充优惠的唯一出处。
 *
 * <p>「首充」指的是 pay 页新用户档位里 50 元那一条：充 50 送 5，仅限 1 次，
 * 充了别的金额首充资格就作废（见 views/pay/index.vue 的 selectPrice）。
 *
 * <p>这几处的数字必须始终一致，改档位时只改本文件，然后同步后端：
 * <ol>
 *   <li>views/pay/index.vue —— 新用户 payList 里 price=50 的那条</li>
 *   <li>后端 PicDownloadUtil.checkPrice 的子站首充白名单（不改的话下单会被判成非法请求）</li>
 *   <li>views/advert/advertCenter.vue 新人首充弹窗</li>
 *   <li>views/temporaryDownload/module/invitePop.vue 次卡用完的注册引导</li>
 * </ol>
 *
 * <p>之前弹窗上的数字是印在图片 userpop.png 里的（首充50送12、赠24%），
 * 档位一改就和实际到账对不上，只能把整个弹窗关掉。改成从这里取值就不会再出现这种情况。
 */
export const FIRST_CHARGE_PRICE = 50;
//2026-08-22 恢复成 50 送 12（24%）。这一档在后端 checkPrice 顶部那张无条件白名单里
//本来就有 map.put("50","12")，早于 one-like 那张表被匹配，所以改回来不需要动后端。
export const FIRST_CHARGE_GIVE = 12;

/** 赠送比例，取整到百分号（5/50 = 10%） */
export const FIRST_CHARGE_PERCENT = Math.round(
  (FIRST_CHARGE_GIVE / FIRST_CHARGE_PRICE) * 100
);

/** 次卡注册引导里那行红字 */
export function firstChargeText() {
  return (
    "注册后首充" +
    FIRST_CHARGE_PRICE +
    "元送" +
    FIRST_CHARGE_GIVE +
    "元，仅限1次"
  );
}
